import { createSelector } from "reselect";
import { camelize } from "humps";

export const getScopedState = (state) => state.context;

export const getScopedCartState = (state) => state.cartResourcesReducer;

export const getResources = createSelector(
	[getScopedState],
	(scopedState) => {
		return scopedState ? scopedState.resources : null;
	}
);

export const getCartResources = createSelector(
	[getScopedCartState],
	(scopedState) => {
		return scopedState ? scopedState.resources : null;
	}
);

export const getSettings = createSelector(
	[getScopedState],
	(scopedState) => {
		return scopedState ? scopedState.settings : null;
	}
);

export const getResourceByKey = (key) =>
	createSelector(
		[getResources],
		(resources) => {
			if (!key) {
				console.error(
					`[Context Selectors]: getResourceByKey needs a key to search. Key received: ${key}`
				);
				return null;
			}
			const camelizedKey = camelize(key);

			return resources ? resources[camelizedKey] : null;
		}
	);
